module.exports = __webpack_public_path__ + "img/rcmk4.5df9c30c.jpg";